module.exports = __webpack_public_path__ + "static/Lucas_Rubrik_Eng-042bf663fa1e1292d1faa00299447920.svg";